import generateConfig from "../../util/config";
import { useRouter } from "next/router";
import React, { ReactNode } from "react";

interface MetaCompProps {
  WrapperComp: ({ children }: { children: ReactNode }) => JSX.Element;
  title: string;
  description: string;
  keywords?: string;
  img?: string;
  content?: string;
  url?: string;
}

const config = generateConfig();

export default function MetaComp({
  WrapperComp,
  title,
  description,
  keywords,
  img,
  content,
  url,
}: MetaCompProps) {
  const { asPath } = useRouter();
  const baseUrl = config.siteUri ? config.siteUri.replace(/\/$/, "") : "";
  const canonicalUrl = url ? url : `${baseUrl}${asPath}`;
  const imageUrl = img
    ? img.startsWith("http")
      ? img
      : `${baseUrl}${img}`
    : undefined;
  return (
    <WrapperComp>
      <title>{title}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={content ? content : "website"} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={imageUrl} />
      {keywords ? (
        <meta name="keywords" content={keywords} />
      ) : config.logoName ? (
        <meta
          name="keywords"
          content={`${config.logoName}, Krushna Raut, portfolio, experienced full-stack developer, React developer`}
        />
      ) : null}
    </WrapperComp>
  );
}
